'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

// check to make modal work with SSR
var domBody = typeof document === 'undefined' ? null : document.body;

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.onEntered = function () {
      // set overflow: hidden in <body> so the user cannot scroll
      // when modal is open
      // Note: Mutiple arguments for classList.add() is not supported in IE
      document.body.classList.add('modal-opened');
      document.body.classList.add('animation-open');

      // focus close-button on enter
      if (_this.closeButton) {
        _this.closeButton.focus();
      }

      // adding fpti
      var el = document.querySelectorAll('.modal-wrapper [data-pa-click]');
      for (var i = 0; i < el.length; i += 1) {
        el[i].addEventListener('click', _this.getFptiVal);
      }

      _this.props.onEntered();
    };

    _this.onHide = function () {
      // remove overflow: hidden to allow scroll
      document.body.classList.remove('modal-opened', 'animation-open');

      // set time out so the modal background will fade out due to the
      // removal of 'animation-open' class, and then close the modal
      setTimeout(function () {
        // modal close hard coded value
        var value = 'Modal-Btn-Close';
        _this.props.fireTracking(value);
        _this.props.onHide();
        _this.props.closeModal();
      }, 300);
    };

    _this.getFptiVal = function (e) {
      var value = e.currentTarget.getAttribute('data-pa-click');
      _this.props.fireTracking(value);
    };

    _this.handleKeyDown = function (e) {
      if (e.keyCode === 27) {
        _this.onHide();
      }
    };

    if (props.bodyRef) {
      domBody = props.bodyRef;
    }
    _this.modalContainer = typeof document === 'undefined' ? null : document.createElement('div');
    return _this;
  }

  /*
    Note that there are two ways that Modal are used:
    1. The parent organism/page imports Modal, directly returns it,
    and hides it by setting show=false. In this case, we reply on
    componentDidUpdate to trigger onEntered().
    2. The parent organism/page does not return <Modal /> until some
    conditions are met. In this case, we reply on componentDidMount
    to trigger onEntered().
    Only one of these two will trigger onEntered().
  */


  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.bodyRef) {
        domBody = this.props.bodyRef;
      }
      if (this.props.show && domBody) {
        domBody.appendChild(this.modalContainer);
        this.onEntered();
      }
    }

    // !prevProps.show prevents component from updating and fading if
    // update is caused by a setState() re-render of other components

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.bodyRef) {
        domBody = this.props.bodyRef;
      }
      if (this.props.show && domBody && !prevProps.show) {
        domBody.appendChild(this.modalContainer);
        this.onEntered();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (domBody && domBody.contains(this.modalContainer)) {
        domBody.removeChild(this.modalContainer);
      }
    }

    // get fpti value


    // close the modal once the user press the escape key

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = (0, _classnames2.default)('modal-wrapper', this.props.className);

      if (this.props.show && this.modalContainer) {
        return _reactDom2.default.createPortal(_react2.default.createElement(
          'div',
          { className: classes, onKeyDown: this.handleKeyDown },
          _react2.default.createElement('div', { className: 'modal-background', onClick: this.onHide }),
          _react2.default.createElement(
            'div',
            { className: 'modal-content-div' },
            _react2.default.createElement(
              'div',
              { className: 'modal-header-div' },
              _react2.default.createElement('button', {
                ref: function ref(el) {
                  _this2.closeButton = el;
                },
                className: 'close-button',
                onClick: this.onHide
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal-body-div' },
              this.props.children
            )
          )
        ), this.modalContainer);
      }

      return null;
    }
  }]);

  return Modal;
}(_react.Component);

exports.default = Modal;


Modal.propTypes = {
  bodyRef: _propTypes2.default.object,
  children: _propTypes2.default.element,
  className: _propTypes2.default.string,
  closeModal: _propTypes2.default.func,
  fireTracking: _propTypes2.default.func,
  onEntered: _propTypes2.default.func,
  onHide: _propTypes2.default.func,
  show: _propTypes2.default.bool.isRequired
};

Modal.defaultProps = {
  children: [],
  className: '',
  bodyRef: undefined,
  closeModal: function closeModal() {},
  fireTracking: function fireTracking() {},
  onEntered: function onEntered() {},
  onHide: function onHide() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/modal/jsx/MPPModal.js
// module id = 687
// module chunks = 4